// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j5Lf","rootMobile":"styles_rootMobile__1d9tZ"};